module.exports = __webpack_public_path__ + "img/ukg.137075de.png";